export const API_URL = process.env.REACT_APP_BUY_API_URL || '';
export const request = async (path, options = {}) => {
  const response = await fetch(`${API_URL}${path}`, {credentials:'include', ...options, headers: { 'Content-Type': 'application/json', ...(options.headers || {}) } });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(typeof body.detail==='string'?body.detail:Array.isArray(body.detail)?body.detail.map(e=>e.msg).join('; '):'The request could not be completed. Please try again.');
  return body;
};
export const getCatalog = () => request('/api/catalog');
export const getStore = () => request('/api/store');
export const createOrder = payload => request('/api/orders', {method:'POST',body:JSON.stringify(payload)});
export const savedOrders = () => {try{return JSON.parse(localStorage.getItem('buy-orders-v2')||'[]')}catch{return []}};
export const saveOrder = order => localStorage.setItem('buy-orders-v2',JSON.stringify([order,...savedOrders().filter(o=>o.order_id!==order.order_id)].slice(0,50)));
export const getOrder = orderId => request(`/api/orders/${orderId}`,{headers:{'X-Order-Token':savedOrders().find(o=>o.order_id===orderId)?.access_token||''}});
export const getQuote = payload => request('/api/quote', {method:'POST',body:JSON.stringify(payload)});
export const consumeOrderLink = () => {
  const url = new URL(window.location.href);
  const token = new URLSearchParams(url.hash.slice(1)).get('access_token');
  if (!token) return;
  const id = url.searchParams.get('orderId');
  // Strip the private token before rendering or making API requests.
  window.history.replaceState(window.history.state, '', url.pathname + url.search);
  if (/^[a-f0-9-]{36}$/i.test(id || '') && /^[a-f0-9]{64}$/i.test(token)) {
    saveOrder({...savedOrders().find(o => o.order_id === id), order_id:id, access_token:token});
  }
};
